export function bullseyeEnrollmentEntries(registrationId, groups, selectedIds, existing = []) {
  const assigned = existing.filter(entry => entry.metadata?.gunGroupId);
  const unassigned = existing.filter(entry => !entry.metadata?.gunGroupId);
  const selected = groups.filter(group => selectedIds.includes(group.gunGroupId) &&
    !assigned.some(entry => entry.metadata.gunGroupId === group.gunGroupId));
  if (!existing.length && !selected.length) throw new Error("Select at least one scoring firearm group before confirming.");
  if (selected.length < unassigned.length) throw new Error("Select a scoring firearm group for each unassigned entry before confirming.");
  if (!selected.length) return existing;
  return [...assigned, ...selected.map((group, index) => ({
    entryId: unassigned[index]?.entryId || `${registrationId}-${group.gunGroupId}-entry-1`,
    attemptIndex: 1,
    status: "active",
    countsForLeaderboard: true,
    isCountingOverride: false,
    ...unassigned[index],
    entryType: "bullseye_gun_group",
    entryLabel: group.title,
    metadata: { ...unassigned[index]?.metadata, gunGroupId: group.gunGroupId },
  }))];
}

export async function confirmBullseyeEnrollment({ registration, groups, selectedIds, entries },
  { updateEntry, confirmRegistration, onEntriesUpdated = () => {} }) {
  if (typeof registration.updatedAt !== "string" || !registration.updatedAt.trim()) {
    throw new Error("Refresh this registration before confirming it.");
  }
  let enrollment = bullseyeEnrollmentEntries(registration.registrationId, groups, selectedIds, entries);
  const repairs = enrollment.flatMap(entry => {
    const saved = entries.find(existing => existing.entryId === entry.entryId);
    if (!saved || saved.metadata?.gunGroupId) return [];
    if (typeof saved.updatedAt !== "string" || !saved.updatedAt.trim()) {
      throw new Error("Refresh this scoring entry before updating it.");
    }
    return [{ entryId: entry.entryId, body: {
      expectedUpdatedAt: saved.updatedAt,
      entryType: entry.entryType,
      entryLabel: entry.entryLabel,
      metadata: entry.metadata,
    } }];
  });
  for (const repair of repairs) {
    const receipt = await updateEntry(repair.entryId, repair.body);
    if (receipt?.entry?.entryId !== repair.entryId || !receipt.entry.updatedAt ||
        receipt.entry.metadata?.gunGroupId !== repair.body.metadata.gunGroupId) {
      throw new Error("Scoring entry repair was not acknowledged. Refresh the roster before confirming.");
    }
    const accepted = receipt.entries || [receipt.entry];
    onEntriesUpdated(accepted);
    enrollment = enrollment.map(entry => accepted.find(saved => saved.entryId === entry.entryId) || entry);
  }
  return confirmRegistration(registration.registrationId, {
    entries: enrollment, expectedUpdatedAt: registration.updatedAt,
  });
}
